// login para tecnico
export const LOGIN_MUTATION = `
  mutation($email: String!, $password: String!) {
    loginAdmin(email: $email, password: $password) {
      message
      user {
        id
        email
        ci
        type_user
        token
      }
      role { name }
      permissions { id name }
    }
  }
`;
// logout general del lado web
export const LOGOUT_MUTATION = `
  mutation {
    logout {
      message
    }
  }
`;

export const CREATE_USER = `
  mutation createUser($userRequest: JSON) {
      createUser(userRequest: $userRequest) {
          id
          email
      }
  }
`;

export const ANULL_USER = `
  mutation anullUserAdm($id_user: String) { 
    anullUserAdm(id_user: $id_user) { 
      message 
      users { email } 
    } 
  }
`;

export const UP_USER = `
  mutation upUserAdm($id_user:String){
    upUserAdm(id_user:$id_user){
      message
      users { email }
    }
  }
`;